<div class="container-fluid">
  <mat-tab-group>
    <mat-tab label="Événements">
      <ng-template matTabContent>
        <app-admin-events></app-admin-events>
      </ng-template>
    </mat-tab>
    <mat-tab label="Biens">
      <ng-template matTabContent>
        <app-admin-properties></app-admin-properties>
      </ng-template>
    </mat-tab>
    <mat-tab label="Utilisateurs">
      <ng-template matTabContent>
        <app-admin-users></app-admin-users>
      </ng-template>
    </mat-tab>
    <mat-tab label="Abonnements">
      <ng-template matTabContent>
        <app-admin-subscriptions></app-admin-subscriptions>
      </ng-template>
    </mat-tab>
    <mat-tab label="Paiements">
      <ng-template matTabContent>
        <app-admin-payments></app-admin-payments>
      </ng-template>
    </mat-tab>
    <mat-tab label="Ventes">
      <ng-template matTabContent>
        <app-admin-property-sales></app-admin-property-sales>
      </ng-template>
    </mat-tab>
    <mat-tab label="Demandes Certification">
      <ng-template matTabContent>
        <app-admin-certification-requests></app-admin-certification-requests>
      </ng-template>
    </mat-tab>
    <mat-tab label="Partenaires">
      <ng-template matTabContent>
        <app-admin-companies></app-admin-companies>
      </ng-template>
    </mat-tab>
    <mat-tab label="Autres">
      <ng-template matTabContent>
        <app-admin-others></app-admin-others>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>